import './PlayerMessage.css';
import React from 'react';

const UnsupportedPlaybackMessage = ({ mediaTitle }) => {
  return (
    <div className="player-message">
      <div className="container">
        <div className="player-message__content">
          <p>
            <strong style={{ lineHeight: 2 }}>
              You are almost ready to watch: <br /> {mediaTitle}
            </strong>
          </p>
          <p>
            The content protection requirements for this programme is not
            supported on your browser.
          </p>
          <p>
            To continue watching this programme, please refer to this{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://mewatch.force.com/helpcentre/s/article/What-devices-can-I-use-to-watch-meWATCH"
            >
              link
            </a>{' '}
            for the supported browsers.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnsupportedPlaybackMessage;
